import { http } from './http'

export interface ScanTicketResponse {
  name: string
  ticketType: string
  email: string
  phone: string
}

export const scanCheckIn = (ticketCode: string) =>
  http.post<ScanTicketResponse>('/operations/ticket/scan/check-in', {
    ticketCode,
  })

export const scanCheckOut = (ticketCode: string) =>
  http.post<ScanTicketResponse>('/operations/ticket/scan/check-out', {
    ticketCode,
  })
